import addSeconds from 'date-fns/addSeconds'
import formatDate from 'date-fns/format'
import { log } from '.'

// const pad = (num: number) => (num < 10 ? `0${num}` : num)

// This is for normalizing date strings for safari
// Safari cannot parse date strings in yyyy-mm-dd format, they must be in yyyy/mm/dd format
export const normalizeDateStr = (dateStr: string) =>
	dateStr.replace(/-/g, '/').replace('T', ' ').split('.')[0]

type FormatUTCOpts = {
	debug?: boolean
	format?: string
	errorHandler?: (err: Error) => void
}
export const formatUTC = (utc: string, options?: FormatUTCOpts | string) => {
	const errorHandler = typeof options !== 'string' ? options?.errorHandler : null
	let opts = {
		format: typeof options === 'string' ? options : 'MM/dd/yyyy',
	} as Omit<FormatUTCOpts, 'format'> & {
		format: string
	}

	if (typeof options === 'object') {
		opts = {
			...opts,
			...options,
		}
	}
	const { debug, format } = opts || {}

	if (!utc) return utc

	if (debug) log('formatUTC | beginning with date: ', utc)

	let formattedDate = ''
	const normalizedDateStr = normalizeDateStr(utc)

	if (debug) log('formatUTC | normalized date: ', normalizedDateStr)

	try {
		const newDate = new Date(normalizedDateStr)

		formattedDate = formatDate(newDate, format)
	} catch (err) {
		errorHandler && errorHandler(err as Error)
		return utc
	}

	return formattedDate
}

export const formatHtmlDateForUTC = (dateVal: string, opts?: { debug?: boolean }) => {
	if (!dateVal) return dateVal
	const { debug } = opts || {}
	if (debug) log('formatHtmlDateForUTC | beginning with: ', dateVal)
	const normalizedDate = normalizeDateStr(`${dateVal} 12:00:00`)
	const utcDate = new Date(normalizedDate)
	return utcDate.toDateString()
}

export const formatDateForHtmlDateField = (UTC: string) => {
	return formatUTC(UTC, 'yyyy-MM-dd')
}

export const addSecondsToDate = addSeconds
